import { useContext, useState, useRef } from 'react';
import { Container, Row, Col, Table, Spinner, Form, InputGroup, Button } from 'react-bootstrap';
import $ from 'jquery';
import ReactToPrint from "react-to-print";
import generatePDF from 'react-to-pdf';
import { AppContext } from '../App';


export const ExpenseReport = () => {
	const { postCall, load, setLoad, getDate, expenseReport, setExpenseReport, expenseParti, downloadExcel } = useContext(AppContext);
	const [dateRange, setDateRange] = useState('');
	const tableRef = useRef(null);

	const getReport = (e) => {
		e.preventDefault();
		let start = e.target.start.value;
		let end = e.target.end.value;
		let staff = e.target.staff.value;
		let partic = e.target.partic.value;
		if (start !== "" && end !== "") {
			setLoad(true)
			postCall('api/bnr/get/expense/report/', { start_date: start, end_date: end, staff_id: staff, p_id: partic }).then(res => {
				setExpenseReport(res.data);
				setDateRange(`report_expense_from_${start}_to_${end}`);
				setLoad(false);
			}).catch(err => {
				setLoad(false);
			});
		}
	}

	const formatExcel = () => {
		if (expenseReport !== undefined && expenseReport.expense_values !== undefined && Object.keys(expenseReport.expense_values).length > 0) {
			let data = [];
			Object.keys(expenseReport.expense_values).map(exp => {
				data.push({
					'Particulars': expenseReport.expense_values[exp].particulars,
					'Remarks': expenseReport.expense_values[exp].remarks,
					'Staff': expenseReport.expense_values[exp].created_by,
					'Payment Method': expenseReport.expense_values[exp].payment_type,
					'Amount': parseFloat(expenseReport.expense_values[exp].amount).toFixed(2),
				});
			});
			return data;
		}
	}

	return (
		<div className='container-fluid' >
			<div className='grid2by8 align-items-center bgp br-3 p-2 mb-2' >
				<div className='px-2' >
					{
						load ? (
							<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
						) : (
							<span className='text-white' >Expense Report</span>
						)
					}
				</div>
				<Form onSubmit={getReport} >
					<Row>
						<Col xs={12} sm={4} md={2} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">From</InputGroup.Text>
								<Form.Control name="start" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={2} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">To</InputGroup.Text>
								<Form.Control name="end" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={3} >
							<Form.Select name="staff" className="shadow-none br-2">
								<option value="" >All staffs</option>
								{
									expenseReport !== undefined ? (
										expenseReport.users !== undefined ? (
											Object.keys(expenseReport.users).length > 0 ? (
												Object.keys(expenseReport.users).map((staff, staff_i) => (
													<option value={staff.substring(1)} key={`user_${staff_i}`} >{expenseReport.users[staff].username}</option>
												))
											) : ''
										) : ''
									) : ''
								}
							</Form.Select>
						</Col>
						<Col xs={12} sm={4} md={3} >
							<Form.Select name="partic" className="shadow-none br-2">
								<option value="" >All Particulars</option>
								{
									expenseParti !== undefined && Object.keys(expenseParti).length > 0 ? (
										Object.keys(expenseParti).map((parti, pi) => (
											<option value={parti.substring(1)} key={`part_${pi}`} >{expenseParti[parti].name}</option>
										))
									) : ''
								}
							</Form.Select>
						</Col>
						<Col xs={12} sm={4} md={2} className="d-grid" >
							<Button type="submit" className="btn-t1-r br-3" >Get Report</Button>
						</Col>
					</Row>
				</Form>
			</div>
			{
				expenseReport !== undefined && expenseReport.expense_values !== undefined && Object.keys(expenseReport.expense_values).length > 0 ? (
					<div className='d-flex justify-content-end align-items-center mb-2 gap-2' >
						<span>Download</span>
						<Button className="br-1" onClick={() => {
							downloadExcel(formatExcel(), `${dateRange}.xlsx`);
						}} size='sm' variant='success' ><i className='bi bi-download' ></i> Excel</Button>
						<Button onClick={() => {
							generatePDF(tableRef, { filename: `${dateRange}.pdf` });
						}} size='sm' className='br-1' variant='success' ><i className='bi bi-download' ></i> Pdf</Button>
						<ReactToPrint
							trigger={() => <Button className='br-1' variant='success' size='sm'><i className="bi bi-printer"></i> Print</Button>}
							content={() => tableRef.current}
						/>
					</div>
				) : null
			}
			<div ref={tableRef}>
				<Table bordered className="tbl-bg-blue" >
					<thead>
						<tr>
							<th className="tp2" >Particulars</th>
							<th className="tp2" >Remarks</th>
							<th className="tp2" >Staff</th>
							<th className="tp2" >
								<div className='grid6by4 align-items-center justify-content-between'>
									<span className="tp2 " >Payment method</span>
									<span className="tp2  text-end" >Amount</span>
								</div>
							</th>
						</tr>
					</thead>
					<tbody>
						{
							expenseReport !== undefined && Object.keys(expenseReport.expense_values).length > 0 ? (
								Object.keys(expenseReport.expense_values).map((exp, exi) => (
									<tr key={`exp_${exi}`} className="tc2" >
										<td>
											<span className="d-grid" >{expenseReport.expense_values[exp].particulars}</span>
										</td>
										<td>{expenseReport.expense_values[exp].remarks}</td>
										<td>{expenseReport.expense_values[exp].created_by}</td>
										<td>
											<div className='grid6by4'>
												<span>{expenseReport.expense_values[exp].payment_type}</span>
												<span className="text-end" >{parseFloat(expenseReport.expense_values[exp].amount).toFixed(2)}</span>
											</div>
										</td>
									</tr>
								))
							) : ''
						}
						<tr>
							<td colSpan={3} className="text-end"></td>
							<td className='bgy' >
								{
									expenseReport !== undefined && expenseReport.main.expense_total !== undefined && Object.keys(expenseReport.main.expense_total).length > 0 ? (
										Object.keys(expenseReport.main.expense_total).map((ex, exi) => (
											<div class="grid6by4 align-items-center justify-content-between bdr0-b py-1" key={`bpay_${exi}`} >
												<span className="tp2 " >{ex}</span>
												<div className='d-flex justify-content-end' >
													<span className="tp2 " >{parseFloat(expenseReport.main.expense_total[ex]).toFixed(2)}</span>
												</div>
											</div>
										))
									) : ''
								}
								<div class="grid6by4 align-items-center justify-content-between py-2" >
									<span className="f20" >Total</span>
									<div className='d-flex justify-content-end' >
										<span className="f20" >{expenseReport !== undefined && expenseReport.main !== undefined ? parseFloat(expenseReport.main.total).toFixed(2) : ''}</span>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</Table>
			</div>
		</div>
	)
}